export default __webpack_public_path__ + "static/media/Flowers02.c6c7269c.jpg";